import type { FrontendWidget } from '../types';
import { LocationFeaturesWidgetComponent } from './LocationFeaturesWidgetComponent';
import { LocationFeaturesWidgetComponentB } from './LocationFeaturesWidgetComponentB';
import { LocationFeaturesWidgetComponentC } from './LocationFeaturesWidgetComponentC';
import type { LocationFeaturesConfig, LocationFeaturesResolved } from './types';

export const locationFeaturesWidget: FrontendWidget<
  LocationFeaturesConfig,
  LocationFeaturesResolved
> = {
  componentType: 'widgets.location-features',
  // 70.14: SlotRenderer adds no container — full-bleed. The widget paints a
  // background band from `md`, and a band constrained to the content column
  // would stop at 1152px with white bars either side.
  layout: 'self',
  displayName: 'Location Features',
  defaultValues: { blocks: [] },
  ComponentA: LocationFeaturesWidgetComponent,
  ComponentB: LocationFeaturesWidgetComponentB,
  ComponentC: LocationFeaturesWidgetComponentC,
  resolveSync: (config) => ({
    items: (config.blocks ?? []).map((item) => ({
      title: item.title ?? '',
      description: item.description ?? '',
      iconDesktop: item.iconDesktop ?? '',
      iconMobile: item.iconMobile ?? '',
    })),
  }),
};
